module.exports = __webpack_public_path__ + "static/media/20240515_142825.4bc9a346.jpg";